import { User } from '../auth/data-types'

export enum StatusEnum {
    WantToRead = 1,
    CurrentlyReading = 2,
    Read = 3,
}

export type Author = {
	id: number
	name: string
}

export type Book = {
	isbn_db?: boolean // if true, book wasn't saved, so we need this for follow. only present in search

    id?: number
	title?: string
	title_long?: string
	book_normalized_title?: string

	ISBN_language?: string
	language?: string

	isbn10: string
	isbn13: string

	club_id?: number
	status_id?: StatusEnum

	image?: string
	bg_color?: string
	synopsys?: string
	overview?: string
	subjects?: string

	publisher?: string
	date_published?: string
	edition?: string
	pages?: string
	dimensions?: string

	format?: string

	creation_date?: string

	authors: Author[]

	affiliate_links: {
		[key: string]: string
	}
}

export type BookWithRating = Book & {
	rating: {
		average: number | null,
		user: number | null
		reviewed_by_me?: boolean
		my_review_id?: number
		reviews_count: number
		ratings_count: number
	}
}

export type BookWithStats = BookWithRating & {
	messages_count: number
	users_amount: number,
	visited: boolean,
	unread_count: {
        messages: 0,
        posts: 0,
        comments: 0
	}
}

export type BookStats = {
	user_count: number
	message_count: number
}

export type BookExtension = {
	book: Book
	stats: BookStats
}

type UserClubStatus = {
	club_id: number
	user_count: number
	is_club_available: boolean
}

export type MinimalClub = {
	id: number
	club_name: string
	club_normalized_name: string
	status_id: StatusEnum
	first_book_id: number
}

export type Club = MinimalClub & {
    title: string
    author: Author[]
    image?: string
    isbn13: string
    books: BookWithStats[]
    users_amount: number
    notifications_settings: {
        is_cafe_notifications_enabled: boolean
        is_salon_notifications_enabled: boolean
        is_join_notifications_enabled: boolean
    },
    all_statuses: { [key in StatusEnum]: UserClubStatus }
    my_status_id?: number
}

export type Review = {
	id?: number
	book_id?: number
	club_id?: number

	title: string
	body: string
	rating: number

	is_spoiler: boolean
	creation_date: string
	updated_at: string | null

	user: User

	likes: {
		count: number
		liked_by_me: boolean
	}

	user_stats: {
		reviews_count: number
		followers_count: number
	}

	book: Book & {
		average_rating: number | null
	}

	club: Club

	is_completed: boolean // if not, it's just a rating
}

export type TrendingClub = {
	id: number
	users_amount: number
	total_users: number
	total_messages: number
	title: string
	image: string
	isbn13: string
	language: string
	authors: string[]
	user_count: number
	message_count: number
	post_count: number
	comment_count: number
	score: number
	my_status_id: StatusEnum | null
	my_club_id: number | null
	books: BookWithRating[]
}

export type TrendingClubList = {
	read: TrendingClub[]
	currently_reading: TrendingClub[]
	want_to_read: TrendingClub[]
}